import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';

import FeatureFlag from '../general/FeatureFlag';

export default function PaymentMethods ({ className }) {
    return (
        <ul className={ `payment-methods-list ${className}` }>
            <FeatureFlag name="enableAmazonPay">
                <li className="payment-methods--amazonpay"><span className="sr-only">{ t('payment.method.amazonPay') }</span></li>
            </FeatureFlag>
            <FeatureFlag name="enablePaypal">
                <li className="payment-methods--paypal"><span className="sr-only">{ t('payment.method.paypal') }</span></li>
            </FeatureFlag>
            <li className="payment-methods--visa"><span className="sr-only">{ t('payment.cardType.visa') }</span></li>
            <li className="payment-methods--mastercard"><span className="sr-only">{ t('payment.cardType.mastercard') }</span></li>
            <li className="payment-methods--maestro"><span className="sr-only">{ t('payment.cardType.maestro') }</span></li>
            <FeatureFlag name="enableAmexPayments">
                <li className="payment-methods--amex"><span className="sr-only">{ t('payment.cardType.amex') }</span></li>
            </FeatureFlag>
            <FeatureFlag name="enableSafeKey">
                <li className="payment-methods--safekey"><span className="sr-only">{ t('payment.security.safekey') }</span></li>
            </FeatureFlag>
        </ul>
    );
}

PaymentMethods.propTypes = {
    className: PropTypes.string
};

PaymentMethods.defaultProps = {
    className: ''
};



// WEBPACK FOOTER //
// ./src/components/payment/PaymentMethods.js